import { externalInvitationSlice } from './../external-invitation.slice';

export const clearExternalInvitations =
  externalInvitationSlice.actions.clearExternalInvitations;
